import {
  Grid,
  Box,
  Typography,
  Button,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { CheckCircle, MoreHoriz, ExpandMore } from "@mui/icons-material";
import { useState } from "react";

import { get } from "src/utils/networkUtils";

export default function PromotionCheck({ divisions, stagePeriodId }) {
  const [loadingStates, setLoadingStates] = useState({});
  const [results, setResults] = useState({});

  const checkDivisionPromotion = (divisionId) => {
    setLoadingStates(prev => ({ ...prev, [divisionId]: true }));

    get(`/admin/divisions/${divisionId}/check-promotion?stagePeriodId=${stagePeriodId}`)
      .then(function (response) {
        console.log(`Division ${divisionId} result:`, response);
        setResults(prev => ({ ...prev, [divisionId]: response }));
      })
      .catch(function (error) {
        console.error(`Division ${divisionId} error:`, error);
        setResults(prev => ({ ...prev, [divisionId]: { error: error.message } }));
      })
      .finally(() => {
        setLoadingStates(prev => ({ ...prev, [divisionId]: false }));
      });
  };

  const runAllChecks = () => {
    divisions.forEach(division => {
      checkDivisionPromotion(division.divisionId);
    });
  };

  return (
    <Accordion sx={{ mb: 2 }}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="promotion-check-content"
        id="promotion-check-header"
      >
        <Typography variant="h6">Promotion Results Check</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} sx={{ mb: 4 }}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={runAllChecks}
              disabled={Object.values(loadingStates).some(loading => loading)}
              sx={{ mb: 2 }}
            >
              Run Check
            </Button>
          </Grid>

          {divisions.map((division) => (
            <Grid item xs={3} key={division.divisionId}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Typography variant="h6">
                    {division.divisionName}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right', pr: 2 }}>
                  {loadingStates[division.divisionId] && (
                    <CircularProgress size={24} />
                  )}
                  {!loadingStates[division.divisionId] && !results[division.divisionId] && (
                    <MoreHoriz color="disabled" />
                  )}
                  {results[division.divisionId] && !loadingStates[division.divisionId] && (
                    <>
                      {(() => {
                        const result = results[division.divisionId];
                        const notPromotedCount = result.notPromotedUsersCount || 0;
                        const notUpdatedCount = result.notUpdatedUserIdsCount || 0;

                        if (notPromotedCount > 0 || notUpdatedCount > 0) {
                          return (
                            <Box>
                              <Typography variant="body1" color="warning.main" sx={{ ml: 1 }}>
                                Promote: {notPromotedCount}, Assign: {notUpdatedCount}
                              </Typography>
                            </Box>
                          );
                        } else {
                          return <CheckCircle color="success" />;
                        }
                      })()}
                    </>
                  )}
                </Grid>
              </Grid>

            </Grid>
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
